import { Box, Grid } from "@mui/material"
import BreadCrumbs from "components/Breadcrumbs/Breadcrumbs"
import DrawerHeader from "components/DrawerHeader"
import { CommonTexts } from "locale/es"
import DisplayForms from "./DisplayForms"
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faWpforms } from "@fortawesome/free-brands-svg-icons";
import { AppColors } from "resources/AppColors"

const FormsConfiguration = () =>
  <Box component="main" sx={{ flex: 1, p: 3, mb: 20 }}>
    <DrawerHeader />
    <BreadCrumbs name={CommonTexts.FORMS} icon={<FontAwesomeIcon icon={faWpforms} size='xs' fixedWidth style={{ color: AppColors.PRIMARY, marginRight: "4px" }} />} />
    <Grid
      container
      direction="column"
      justifyContent="center"
      alignItems="center"
      width="100%"
    >
      <DisplayForms />
    </Grid>
  </Box>

export default FormsConfiguration